import React from "react";
import CarouselCard from "./CarouselCard";
import { CarWithDealer } from "../data/models";

export interface CarouselProps {
  data: CarWithDealer[];
  scrollContainerRef: React.RefObject<HTMLDivElement>;
}

export function Carousel(props: CarouselProps) {
  const { data, scrollContainerRef } = props;

  return (
    <div
      ref={scrollContainerRef}
      className="flex gap-4 overflow-x-auto snap-x snap-mandatory scrollbar-hide"
    >
      {data.map((item, index) => (
        <div
          key={index}
          className="
              flex-shrink-0 snap-start
              w-[calc(100%-24px)] 
              sm:w-[calc(50%-16px)] 
              lg:w-[calc(33.33%-16px)]
              2xl:w-[calc(25%-16px)] 
              min-[2300px]:w-[calc(20%-12px)]
              "
        >
          <CarouselCard data={item} />
        </div>
      ))}
    </div>
  );
}

export default Carousel;
